import { Injectable } from '@angular/core';

@Injectable()
export class EnterpAtlasService {

  constructor() { }

  //图谱
  getEnterMap() {
    let data = {
      'Status' : 200,
      'Result' :
        {'Category':1, 'depth':0,
        'children':[
          {'Category':2, 'depth':1, 'name':'股东', 'Count':2,
            'children':[{'name': '张子方', 'Category':2, 'depth':2, 'Count':0},
                        {'name':'苏州中集投资管理中心（有限合伙）', 'Category':2, 'depth':2, 'Count':0}]},
          {'Category':3, 'depth':1, 'name':'高管', 'Count':8,
            'children':[{'name':'李宁', 'Category':3, 'depth':2, 'Count':0},
                        {'name':'程亮', 'Category':3, 'depth':2, 'Count':0},
                        {'name':'张子方', 'Category':3, 'depth':2, 'Count':0},
                        {'name':'臧宇澄', 'Category':3, 'depth':2, 'Count':0},
                        {'name':'罗俊', 'Category':3, 'depth':2, 'Count':0},
                        {'name':'刘号', 'Category':3, 'depth':2, 'Count':0},
                        {'name':'张安清', 'Category':3, 'depth':2, 'Count':0},
                        {'name':'孙丽萍', 'Category':3, 'depth':2, 'Count':0}]},
          {'depth':1, 'children':[], 'Category':4, 'name':'分支机构', 'Count':0},
          {'depth':1, 'children':[], 'Category':5, 'name':'对外投资', 'Count':0},
          {'depth':1, 'children':[], 'Category':6, 'name':'法院判决', 'Count':0}],
          'name':'江苏未至科技股份有限公司', 'Count':10}};
    return data;
  }
  //关联链图
  getEnterGL() {
    let dataGL = {
      Status:200,
      Result:{
        Links:[{Target:'江苏未至科技股份有限公司', Relation:'法定代表人,董事长兼总经理,股东', Source:'张子方'},
          {Target:'江苏未至科技股份有限公司', Relation:'董事', Source:'刘号'},
          {Target:'江苏未至科技股份有限公司', Relation:'董事', Source:'程亮'},
          {Target:'江苏未至科技股份有限公司', Relation:'董事', Source:'李宁'},
          {Target:'江苏未至科技股份有限公司', Relation:'董事', Source:'臧宇澄'},
          {Target:'江苏未至科技股份有限公司', Relation:'监事', Source:'孙丽萍'},
          {Target:'江苏未至科技股份有限公司', Relation:'监事', Source:'张安清'},
          {Target:'江苏未至科技股份有限公司', Relation:'监事', Source:'罗俊'},
          {Target:'江苏未至科技股份有限公司', Relation:'股东', Source:'苏州中集投资管理中心（有限合伙）'},
          {Target:'苏州中集投资管理中心（有限合伙）', Relation:'法定代表人,股东', Source:'张子方'},
          {Target:'苏州中集投资管理中心（有限合伙）', Relation:'股东', Source:'刘号'},
          {Target:'苏州中集投资管理中心（有限合伙）', Relation:'股东', Source:'张安清'},
          {Target:'苏州中集投资管理中心（有限合伙）', Relation:'股东', Source:'程亮'},
          {Target:'苏州中集投资管理中心（有限合伙）', Relation:'股东', Source:'罗俊'},
          {Target:'苏州中集投资管理中心（有限合伙）', Relation:'股东', Source:'臧宇澄'}],
        Nodes:[{Category:1, Name:'江苏未至科技股份有限公司'},
          {Category:2, Name:'张子方'},
          {Category:2, Name:'刘号'},
          {Category:2, Name:'程亮'},
          {Category:2, Name:'李宁'},
          {Category:2, Name:'臧宇澄'},
          {Category:2, Name:'孙丽萍'},
          {Category:2, Name:'张安清'},
          {Category:2, Name:'罗俊'},
          {Category:1, Name:'苏州中集投资管理中心（有限合伙）'}]}
    };
    return dataGL;
  }
  //股权
  getEnterGQ() {
    let dataGQ = {
      'Status':200,
      'Result':{'KeyNo':'3B3AB60BDB3D48A7E0534AFC200A8DDA', 'Category':'1', 'FundedRatio':'100%', 'grade':'1',
        'Children':[{'KeyNo':'3B3AB60C370548A7E0534AFC200A8DDA', 'Category':2, 'FundedRatio':'95.35%', 'Name':'张子方', 'grade':2},
                    {'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDA', 'Category':1,
                      'Children':[{'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDC', 'Category':'2', 'FundedRatio':'32.60%', 'Name':'程亮', 'grade':3},
                        {'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDB', 'Category':2, 'FundedRatio':'21.52%', 'Name':'张子方', 'grade':3},
                        {'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDE', 'Category':2, 'FundedRatio':'21.15%', 'Name':'刘号', 'grade':3},
                        {'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDD', 'Category':2, 'FundedRatio':'20.86%', 'Name':'臧宇澄', 'grade':3},
                        {'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDF', 'Category':2, 'FundedRatio':'0.63%', 'Name':'张安清', 'grade':3},
                        {'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDG', 'Category':2, 'FundedRatio':'0.63%', 'Name':'罗俊', 'grade':3}],
                      'FundedRatio':'4.65%', 'Name':'苏州中集投资管理中心（有限合伙）', 'grade':2}], 'Name':'江苏未至科技股份有限公司'}
    }
    return dataGQ;
  }
  //控制人
  getEnterKZR() {
    let dataKzr = {
      'Status':200,
      'Result':{'KeyNo':'3B3AB60BDB3D48A7E0534AFC200A8DDA',
        'ActualControllerLoopPath':[{'KeyNo':'3B3AB60C370548A7E0534AFC200A8DDA', 'FundedRatio':'95.34883720930233%', 'Name':'张子方'}],
        'Category':'', 'ActualControllerRadio':'96.34976744186046%', 'FundedRatio':'100%',
        'Links':[{'ActualRadio':'95.34883720930233%', 'Target':'3B3AB60BDB3D48A7E0534AFC200A8DDA', 'CurrentRadio':'95.34883720930233%', 'IsActualController':true, 'Source':'3B3AB60C370548A7E0534AFC200A8DDA'},
          {'ActualRadio':'4.651162790697675%', 'Target':'3B3AB60BDB3D48A7E0534AFC200A8DDA', 'CurrentRadio':'4.651162790697675%', 'IsActualController':false, 'Source':'3B3AB60C370648A7E0534AFC200A8DDA'}, {'ActualRadio':'96.34976744186046%', 'Target':'3B3AB60C370648A7E0534AFC200A8DDA', 'CurrentRadio':'21.52%', 'IsActualController':false, 'Source':'3B3AB60C370548A7E0534AFC200A8DDA'}], 'Grade':1,
        'Nodes':[{'KeyNo':'3B3AB60C370548A7E0534AFC200A8DDA', 'Category':'2', 'Grade':2, 'Name':'张子方'}, {'KeyNo':'3B3AB60C370648A7E0534AFC200A8DDA', 'Category':1, 'Grade':2, 'Name':'苏州中集投资管理中心（有限合伙）'}, {'KeyNo':'3B3AB60BDB3D48A7E0534AFC200A8DDA', 'Category':1, 'Grade':1, 'Name':'江苏未至科技股份有限公司'}], 'Name':'江苏未至科技股份有限公司'}
    }
    return dataKzr;
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/enterp-atlas.service.ts